/**
 * CouponEventDetailsContainer
 * --
 */
import React from 'react';
import CouponEventDetailsPresenter from './CouponEventDetailsPresenter';
import { useParams } from 'react-router-dom';
import { decrypt } from 'utils/Crypto';
import { useDefaultShopDataStack } from 'store';

const CouponEventDetailsContainer = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { navigate, screenSize } = props;
  const { eventId } = useParams();

  // 상품 idx
  const EventIdx = React.useMemo(() => {
    const decodeIdx = decrypt(eventId);
    return Number(decodeIdx);
  }, [eventId]);

  /* ===== Data ===== */
  const { events } = useDefaultShopDataStack();

  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  const EventData = React.useMemo(() => {
    const newEvent = events.find((event) => event.event_id === EventIdx);

    return newEvent;
  }, [events, EventIdx]);
  /* ===== RENDER ===== */
  return (
    <>
      <CouponEventDetailsPresenter
        event={EventData}
        navigate={navigate}
        screenSize={screenSize}
      />
    </>
  );
};

export default CouponEventDetailsContainer;
